/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import {
  Column,
  DataGrid,
  HeaderFilter,
  Pager,
  Paging,
  FilterRow,
} from 'devextreme-react/data-grid';
import { FormGroup, Input } from 'reactstrap';
import { Container } from './styles';
import {
  gridGroupModuloDataSource,
  handleUpdateGrupoModulo,
} from '../../../GruposServices';

function Lista({ setLoading, loading }) {
  const [pageIndex, setPageIndex] = useState(null);
  const [pageSize, setPageSize] = useState(15);

  function handleOptionChange(event) {
    if (event.fullName === 'paging.pageSize' && event.value !== pageSize) {
      setPageSize(event.value);
      setPageIndex(0);
    }

    setPageIndex(null);
  }
  const applyFilterTypes = [
    {
      key: 'auto',
      name: 'Immediately',
    },
    {
      key: 'onClick',
      name: 'On Button Click',
    },
  ];
  const filterOptions = {
    showFilterRow: true,
    showHeaderFilter: true,
    currentFilter: applyFilterTypes[0].key,
  };

  const checkRender = (e) => (
    <FormGroup
      style={{
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Input
        disabled={loading}
        type="checkbox"
        defaultChecked={e.data.check}
        onChange={() => {
          handleUpdateGrupoModulo(
            !e.data.check,
            e.data.id,
            e.data.idGrupo,
            e,
            setLoading
          );
        }}
      />
    </FormGroup>
  );
  return (
    <Container>
      <h1>Grupos </h1>

      <DataGrid
        dataSource={gridGroupModuloDataSource}
        remoteOperations
        showBorders
        allowColumnReordering
        allowColumnResizing
        columnAutoWidth
        onOptionChanged={handleOptionChange}
      >
        <Pager
          visible
          showPageSizeSelector
          allowedPageSizes={[10, 15, 30]}
          showInfo
        />
        <Paging defaultPageSize={pageSize} pageIndex={pageIndex} />
        <FilterRow
          visible={filterOptions.showFilterRow}
          applyFilter={filterOptions.currentFilter}
        />
        <Column
          dataField="idGrupo"
          caption="Id do grupo"
          alignment="left"
          filterOperations={false}
        >
          <HeaderFilter groupInterval={100} />
        </Column>
        <Column
          alignment="left"
          dataField="nome"
          caption="Nome do grupo"
          filterOperations={false}
        >
          <HeaderFilter groupInterval={100} />
        </Column>
        <Column
          alignment="center"
          dataField="check"
          caption="Vincular?"
          editCellRender={checkRender}
          width="20%"
        />
      </DataGrid>
    </Container>
  );
}

export default Lista;
